<template>
    <div>

        <div class="card-body">
            <div class="tab-content">
                <div class="tab-pane active" id="activity">

                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-t">Education</h5>
                            <hr />
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead class="bg-info">
                                        <tr>
                                            <th>Degree</th>
                                            <th>Board</th>
                                            <th>Status</th>
                                            <th>Passing Year</th>
                                            <th>T.M</th>
                                            <th>O.M</th>
                                            <th style="width: 10px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, ind) in educations">
                                            <td>{{item._Degree}}</td>
                                            <td>{{item._Board}}</td>
                                            <td>{{item.DegreeStatus}}</td>
                                            <td>{{item.PassingYear}}</td>
                                            <td>{{item.TotalMarks}}</td>
                                            <td>{{item.ObtainedMarks}}</td>
                                            <td style="white-space: nowrap">
                                                <button class="btn btn-sm btn-info" v-on:click="showEducationModal(item, ind)"><i class="fas fa-edit"></i></button>
                                                <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteEducation" v-on:click="educationIndex = ind;"><i class="fas fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="7">
                                                <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showEducationModal()">Add New</button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-c">Professional Training</h5>
                            <hr />
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead class="bg-info">
                                        <tr>
                                            <th>Title</th>
                                            <th>Type</th>
                                            <th>Field of study</th>
                                            <th>Institution</th>
                                            <th>Year</th>
                                            <th>Grade</th>
                                            <th style="width: 10px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, ind) in professionalTrainings">
                                            <td>{{item.Title}}</td>
                                            <td>{{item._Type}}</td>
                                            <td>{{item.FieldOfStudy}}</td>
                                            <td>{{item.Institution}}</td>
                                            <td>{{item.Year}}</td>
                                            <td>{{item.Grade}}</td>
                                            <td style="white-space: nowrap">
                                                <button class="btn btn-sm btn-info" v-on:click="showModalProfessionalTraining(item, ind)"><i class="fas fa-edit"></i></button>
                                                <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteProfessionalTraining" v-on:click="educationIndex = ind;"><i class="fas fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="7">
                                                <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showModalProfessionalTraining()">Add New</button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!-- /.tab-content -->
        </div>

        <div class="card-footer">
            <a class="btn btn-primary" href="../Employees/List">Back to List</a>
            <div class="float-right">
                <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" />
                <!--<input type="submit" value="Save Profile" class="btn btn-success  " />-->
            </div>
        </div>

        <div class="modal fade" id="modalEducation">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Education</h4>
                    </div>

                    <form id="contact" v-on:submit="saveEducation">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Degree *</label>
                                        <select class="form-control" v-model="education.DegreeID" required>
                                            <option value="">--Select--</option>
                                            <option v-for="item in degrees" :value="item.AggregateTypeID">{{item.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Type *</label>
                                        <select class="form-control" v-model="education.Type" required>
                                            <option value="">--Select--</option>
                                            <option value="0">Annual</option>
                                            <option value="1">Semester</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Board *</label>
                                        <select class="form-control" v-model="education.BoardID" required>
                                            <option value="">--Select--</option>
                                            <option v-for="item in boards" :value="item.BoardID">{{item.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Degree Title *</label>
                                        <input class="form-control" v-model="education.DegreeTitle" required />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Name of School / College / University *</label>
                                        <input class="form-control" v-model="education.Institute" required />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Major/ Specialization *</label>
                                        <input class="form-control" v-model="education.Specialization" required />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Country</label>
                                        <select class="form-control" v-model="education.CountryID">
                                            <option value="0">--Select--</option>
                                            <option v-for="item in countries" :value="item.CountryID">{{item.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Degree Status *</label>
                                        <select class="form-control" required v-model="education.DegreeStatus">
                                            <option selected="selected" disabled="disabled" value="">--Select--</option>
                                            <option>In-Proccess</option>
                                            <option>Completed</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="education.DegreeStatus == 'Completed'">
                                    <div class="form-group">
                                        <label>Passing Year</label>
                                        <input class="form-control" type="number" v-bind:max="maxYear" min="1950" v-model="education.PassingYear" required />
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="education.DegreeStatus == 'Completed'">
                                    <div class="form-group">
                                        <label>Total Marks / GPA</label>
                                        <input type="number" min="0" class="form-control" v-model="education.TotalMarks" required />
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="education.DegreeStatus == 'Completed'">
                                    <div class="form-group">
                                        <label>Obtained Marks / GPA</label>
                                        <input type="number" min="0" :max="education.TotalMarks" class="form-control" v-model="education.ObtainedMarks" required />
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="education.DegreeStatus == 'Completed'">
                                    <div class="form-group">
                                        <label>Grade</label>
                                        <select class="form-control" v-model="education.Grade">
                                            <option selected="selected" disabled="disabled" value="">--Select--</option>
                                            <option>A+</option>
                                            <option>A</option>
                                            <option>A-</option>
                                            <option>B+</option>
                                            <option>B</option>
                                            <option>B-</option>
                                            <option>C+</option>
                                            <option>C</option>
                                            <option>C-</option>
                                            <option>D+</option>
                                            <option>D</option>
                                            <option>D-</option>
                                            <option>F</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="education.DegreeStatus == 'Completed'">
                                    <div class="form-group">
                                        <label>Division</label>
                                        <select id="" class="form-control" v-model="education.Division">
                                            <option selected="selected" disabled="disabled" value="">--Select--</option>
                                            <option>1st</option>
                                            <option>2nd</option>
                                            <option>3rd</option>
                                            <option>4th</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-success">Save changes</button>
                        </div>
                    </form>

                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>

        <div class="modal fade" id="modalDeleteEducation">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Delete</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <h3>Are you sure you want to delete this record ?</h3>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" v-on:click="deleteContact()" class="btn btn-danger">Delete</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>

        <div class="modal fade" id="modalProfessionalTraining">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Professional Training</h4>
                    </div>

                    <form id="labManual" v-on:submit="saveProfessionalTraining">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Title *</label>
                                        <input max="150" class="form-control" v-model="professionalTraining.Title" required />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Type *</label> 
                                        <select class="form-control" v-model="professionalTraining.Type" required>
                                            <option value="0">Diploma</option>
                                            <option value="1">Certificate</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Field of study</label>
                                        <input class="form-control" v-model="professionalTraining.FieldOfStudy" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Institution</label>
                                        <input class="form-control" v-model="professionalTraining.Institution" required />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Year</label>
                                        <input class="form-control" v-mask="'####'" v-model="professionalTraining.Year" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Grade</label>
                                        <input class="form-control" v-model="professionalTraining.Grade" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-success">Save changes</button>
                        </div>
                    </form>

                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>

    </div>
</template>

<script>const axios = require('axios').default;

    export default ({
        props: {
            employeeId: Number,
        },
        data() {
            return {
                educations: [],
                education: {
                    EmployeeEducationID: "",
                    EmployeeID: '',
                    CountryID: 0,
                    BoardID: 0,
                    DegreeID: '',
                    DegreeStatus: '',
                    Type: '',
                    TotalMarks: '',
                    ObtainedMarks: '',
                    Division: '',
                    PassingYear: '',
                    Grade: '',
                    Institute: '',
                },
                educationIndex: -1,
                maxYear: 2022,

                professionalTrainings: [],
                professionalTraining: { Title: '', Type: 0, FieldOfStudy: '', Institution: '', Grade: '', Year: '' },
                professionalTrainingIndex: -1
                 
            }
        },

        created: function () {
            this.pageLoad();
        },

        methods: {

            pageLoad() {
                startReq();
                var vm = this;
                axios.get('/api/EmployeesApi/pageLoadEducation?id=' + vm.employeeId)
                    .then(function (res) {
                        endReq();

                        vm.degrees = res.data.degrees;
                        vm.boards = res.data.boards;
                        vm.countries = res.data.countries;
                        vm.maxYear = res.data.maxYear;

                        if (res.data.educations)
                            vm.educations = res.data.educations;

                        if (res.data.professionalTrainings)
                            vm.professionalTrainings = res.data.professionalTrainings;

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            showEducationModal(data, index) {
                if (data) {
                    this.education = Object.assign({}, data);
                    this.educationIndex = index
                }
                else {
                    this.education = {
                        EmployeeEducationID: "",
                        EmployeeID: '',
                        CountryID: 0,
                        BoardID: 0,
                        DegreeID: '',
                        DegreeStatus: '',
                        Type: '',
                        TotalMarks: '',
                        ObtainedMarks: '',
                        Division: '',
                        PassingYear: '',
                        Grade: '',
                        Institute: '',
                    };
                    this.educationIndex = -1;
                }

                $('#modalEducation').modal('show');
            },

            saveEducation(e) {
                e.preventDefault();
                var vm = this;
                startReq();
                axios.post('/api/EmployeesApi/saveEducation?id=' + vm.employeeId, {
                    education: vm.education
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Saved Successfully", "Done");
                            if (vm.educationIndex == -1)
                                vm.educations.push(res.data.education);
                            else {
                                vm.educations[vm.educationIndex] = res.data.education;
                                vm.educationIndex = -1;
                                $('#modalEducation').modal('hide');
                            }

                            vm.education = {
                                EmployeeEducationID: "",
                                EmployeeID: '',
                                CountryID: 0,
                                BoardID: 0,
                                DegreeID: '',
                                DegreeStatus: '',
                                Type: '',
                                TotalMarks: '',
                                ObtainedMarks: '',
                                Division: '',
                                PassingYear: '',
                                Grade: '',
                                Institute: '',
                            };
                        }
                        else
                            toastr.error(res.data.msg);

                    }).catch(function (err) {
                        endReq();
                        var res = err.response;
                        if (res.status == 401) {
                            toastr.error(res.data);
                        }
                        else {
                            for (const [key, value] of Object.entries(res.data.errors)) {
                                toastr.error(`${value}`);
                            }
                        }
                    })
            },

            deleteEducation() {
                var vm = this;
                startReq();
                axios.get('/api/EmployeesApi/deleteEducation?id=' + vm.educations[vm.educationIndex].EmployeeEducationID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Deleted Successfully", "Done!");
                            vm.educations.splice(vm.educationIndex, 1);
                            vm.educationIndex = -1;
                            $('#modalDeleteEducation').modal('hide');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            showModalProfessionalTraining(data, index) {
                if (data) {
                    this.professionalTraining = Object.assign({}, data);
                    this.professionalTrainingIndex = index
                }
                else {
                    this.professionalTraining = {
                        Title: '', Type: 0, FieldOfStudy: '', Institution: '', Grade: '', Year: ''
                    };
                    this.professionalTrainingIndex = -1;
                }

                $('#modalProfessionalTraining').modal('show');
            },

            saveProfessionalTraining(e) {
                e.preventDefault();
                var vm = this;
                startReq();
                axios.post('/api/EmployeesApi/saveProfessionalTraining?id=' + vm.employeeId, {
                    professionalTraining: vm.professionalTraining
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Saved Successfully", "Done");
                            if (vm.professionalTrainingIndex == -1)
                                vm.professionalTrainings.push(res.data.professionalTraining);
                            else {
                                vm.professionalTrainings[vm.professionalTrainingIndex] = res.data.professionalTraining;
                                vm.professionalTrainingIndex = -1;
                                $('#modalProfessionalTraining').modal('hide');
                            }

                            vm.professionalTraining = { Title: '', Type: 0, FieldOfStudy: '', Institution: '', Grade: '', Year: '' };
                        }
                        else
                            toastr.error(res.data.msg);

                    }).catch(function (err) {
                        endReq();
                        var res = err.response;
                        if (res.status == 401) {
                            toastr.error(res.data);
                        }
                        else {
                            for (const [key, value] of Object.entries(res.data.errors)) {
                                toastr.error(`${value}`);
                            }
                        }
                    })
            },

            deleteProfessionalTraining() {
                var vm = this;
                startReq();
                axios.get('/api/EmployeesApi/deleteProfessionalTraining?id=' + vm.professionalTrainings[vm.professionalTrainingIndex].ProfessionalTrainingID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Deleted Successfully", "Done!");
                            vm.professionalTrainings.splice(vm.professionalTrainingIndex, 1);
                            vm.professionalTrainingIndex = -1;
                            $('#modalDeleteProfessionalTraining').modal('hide');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            clear() {
                this.emp = {
                    OldEmpCode: '',
                    EmpCode: '',
                    SrName: 'Mr.',
                    Name: '',
                    FatherName: '',
                    GenderID: '',
                    DateOfBirth: '',
                    CNIC: '',
                    Detail: { BloodGroup: '', ReligionID: 1, NationalityID: 1, Nationality2: 0, MaritalStatus: '' }
                };
                this.img = '';
                this.sendEmp(null);
                this.sendImg('');
                $('#name').focus();
            }

        }
    })</script>

<style>
    .h4-t {
        margin-top: -9px;
        margin-bottom: -5px;
        font-weight: 600
    }

    .h4-c {
        margin-bottom: -5px;
        font-weight: 600
    }
</style>





// WEBPACK FOOTER //
// src/components/hr/employeeEducation.vue